const tzRe = (
  /'[^']*'|"[^"]*"|y{1,5}|M{1,5}|d{1,5}|E{1,5}|hh?|HH?|mm?|ss?|zzzz|z|a|v/g)

const gmtTimezoneOffset = (d, sep = ':') => (
  d = d.toString().match(/[-+]\d{4}/)[0],
  d.substring(0,3) + sep + d.substr(3))

export default (date, unicodeformat, localeId, symbolMap) => {
  const d = new Date(date)
  const format = unicodeformat
  const year = d.getFullYear()
  const isInRange = year >= 0 && year <= 9999
  const datetimeformat = (d, opt) =>
    new Intl.DateTimeFormat(localeId, opt).format(d)
  const symbolMapFind = (unit, width, idx) =>
    symbolMap && ((symbolMap[unit] || {})[width] || [])[idx]
  const symbolOrDateTimeFormat = (d, unit, width, symbolMapIdx) => (
    symbolMapFind(unit, width, symbolMapIdx)
      || datetimeformat(d, {[unit]: width}))

  if (!isInRange)
    throw new Error('formatDate: year must be 0000-9999')

  return format.replace(tzRe, match => {
    switch (match) {
    case 'y': // year, numeric, full digit year, 1 to 4 digits
      return d.getFullYear()
    case 'yy': // year, numeric, exactly two digit
      return ('0' + d.getFullYear()).slice(-2)
    case 'yyyy': // year, numeric, full year
      return ('000' + d.getFullYear()).slice(-4)
    case 'yyyyy': // year, at least 5 chars
      return ('00000' + d.getFullYear()).slice(-5)
    case 'M': // month, numeric, at least one digit
      return d.getMonth() + 1
    case 'MM': // month, numeric, at least two digits, 0-padding
      return ('0' + (d.getMonth() + 1)).slice(-2)
    case 'MMM': // month, alpha, abbreviated string
      return symbolOrDateTimeFormat(d, 'month', 'short', d.getMonth())
    case 'MMMM': // month, alpha, full string
      return symbolOrDateTimeFormat(d, 'month', 'long', d.getMonth())
    case 'MMMMM': // month, alpha, narrow, one char
      return symbolOrDateTimeFormat(d, 'month', 'narrow', d.getMonth())
    case 'd': // day, numeric, at least one digit
      return d.getDate()
    case 'dd': // day, numeric, at least two digits, 0-padding
      return ('0' + d.getDate()).slice(-2)
    case 'E':
    case 'EE':
    case 'EEE':
    case 'ddd': // day, alpha, abbreviated string
      return symbolOrDateTimeFormat(d, 'weekday', 'short', d.getDate())
    case 'EEEE':
    case 'dddd': // day, alpha, full string
      return symbolOrDateTimeFormat(d, 'weekday', 'long', d.getDate())
    case 'EEEEE':
    case 'ddddd': // day, numeric, at least one digit
      return symbolOrDateTimeFormat(d, 'weekday', 'narrow', d.getDate())
    case 'h': // hour, numeric, at least one digit
      return d.getHours() % 12 || 12
    case 'hh': // hour, numeric, 12pm at least two digits, 0-padding
      return ('0' + (d.getHours() % 12 || 12)).slice(-2)
    case 'H': // hour, numeric, 24pm
      return d.getHours()
    case 'HH': // hour, numeric, 24pm at least two digits, 0-padding
      return ('0' + d.getHours()).slice(-2)
    case 'm': // minute, numeric, at least one digit
      return d.getMinutes()
    case 'mm': // minute, numeric, at least two digits, 0-padding
      return ('0' + d.getMinutes()).slice(-2)
    case 's': // second, numeric, at least one digit
      return d.getSeconds()
    case 'ss': // second, numeric, at least two digits, 0-padding
      return ('0' + d.getSeconds()).slice(-2)
    case 'a': // am, a, pm, p, noon, n (only used with `h`)
      return (d.getHours() < 12) ? 'am' : 'pm'
    case 'zzzz':
      return gmtTimezoneOffset(d, ':')
    case 'z':
      return gmtTimezoneOffset(d, '')
    case 'v': // timezone eg 'PT'. WARNING innacurate,
      // does not return correct value; no good javascript-way to do it
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    default:
      return match
    }
  })
}
